import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useAuth = (dispatch) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        dispatch({ type: 'SET_USER', payload: parsedUser });

        const redirectTo = location.pathname === '/login' ? '/' : location.pathname;
        navigate(redirectTo, { replace: true });
      } catch (e) {
        console.error('Error parsing the stored user in localStorage');
      }
    }
  }, [dispatch, location.pathname, navigate]);
};
